import(/* webpackMode: "eager", webpackExports: ["AppProvider","useApp","useCurrentApp","useAppConfig","useAppSwitcher"] */ "/app/libs/app-config/app-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppSelector","AdvancedAppSelector","AppSwitcherNav"] */ "/app/libs/app-config/app-selector.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/utils/client/domain.ts");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.24_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","success","error","warning","info","promise","custom","dismiss"] */ "/app/node_modules/.pnpm/sonner@2.0.7_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/sonner/dist/index.mjs");
